import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { RenderElementProps } from 'slate-react';
import { TilesPlugin } from '../../toolympus/components/PowerDoc/plugins/Tiles';
import { EditorPlugin } from '../../toolympus/components/PowerDoc';
import { TilesBlockElement, TilesBlockElementType } from '../../toolympus/components/PowerDoc/plugins/Tiles/TilesBlockElement';
import { usePowerEditorContext } from '../../toolympus/components/PowerDoc/slate/PowerEditorContext';
import { Tile } from '../../toolympus/components/PowerDoc/plugins/Tiles/useTiles';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { PossiblyProtectedImg } from '../../toolympus/components/medialib';
import { ArrowForwardIos } from '@mui/icons-material';
import { ThemeSettings } from '../../theme';


export const TilesCustom = (props: RenderElementProps) => {
  const { viewMode } = usePowerEditorContext();

  if(!viewMode) {
    return <TilesBlockElement {...props} />
  }

  const tiles: Tile[] = (props.element as any)?.tiles || [];
  const columns: number | undefined = (props.element as any)?.columns;

  return (
    <CustomTilesWrapper nColumns={columns}>
      {tiles.map(t => {
        const isInternal = t.link?.startsWith("/");

        const insides = t.image_url && !t._class?.includes("icon")
          ? <PossiblyProtectedImg protected src={t.image_url} alt={t.title || ""} />
          : <Typography variant="h4"><span className="label">{t.title}</span> <ArrowForwardIos /></Typography>

        const insides2 = t.image_url && !!t._class?.includes("icon")
          ? <PossiblyProtectedImg className="icon" protected src={t.image_url} alt={t.title || ""} />
          : null;

        return isInternal
          ? (
            <CustomTileL key={t.id} to={t.link || ""}>
              {insides2} {insides}
            </CustomTileL>
          ) : (
            <CustomTileA key={t.id} href={t.link || ""} target="_blank" rel="noreferrer noopener">
              {insides2} {insides}
            </CustomTileA>
          )
      })}
    </CustomTilesWrapper>
  );
}

export const TilesCustomPlugin: EditorPlugin = {
  ...TilesPlugin,
  customBlocks: {
    [TilesBlockElementType]: TilesCustom,
  }
}

const tileCss = css`
  display: flex;
  flex-flow: row;
  align-items: center;

  gap: 8px;
  
  & h4, p {
    margin: 0;
  }

  & img {
    max-width: 300px;
    max-height: 300px;
  }

  & .label {
    text-decoration: underline;
    text-decoration-color: ${ThemeSettings.colors.primary};
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
  }

  & .MuiSvgIcon-root {
    vertical-align: middle;
    transform: scale(0.75) translate(0,-1px);
    color: ${ThemeSettings.colors.primary};
  }

  & .icon {
    height: 24px;
    width: auto;
  }

  text-decoration: none;
  color: inherit;
`;

const CustomTileL = styled(Link)`
  ${tileCss}
  `;

const CustomTileA = styled.a`
  ${tileCss}
`;


const CustomTilesWrapper = styled.div<{ nColumns?: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.nColumns || 3}, 1fr);
  gap: 30px;

  align-items: center;

  @media (max-width: 660px) {
    grid-template-columns: 1fr;
  }
`;